export const api = {
  queryPersonnelgroup: "/bms/personAuthorization/queryPersonnelgroup.json", //查询群组列表
  addPersonnelgroup: "/bms/personAuthorization/addPersonnelgroup.json", //新增群组
  updatePersonnelgroup: "/bms/personAuthorization/updatePersonnelgroup.json", //修改群组
  delPersonnelgroup: "/bms/personAuthorization/deletePersonnelgroup.json", //删除群组
  queryPersonnelByGroup: "/bms/personAuthorization/queryPersonnelByGroup.json", //群组查人
  deleteGroupPersonnel: "/bms/personAuthorization/deletePersonnelGroupPersonnel.json", //群组查人
  peopleSelect: {
    // getPeople: "/bms/turnstilegate/queryTurnstilegatePersonnelList.json", //添加人员的来源
    getPeople: "/bms/personAuthorization/queryPersonnelByGroup.json", //添加人员的来源
    // addAuthority: "/bms/turnstilegate/addTurnstilegateAuthority.json", //新增人员授权
    addGroupPersonnel: "/bms/personAuthorization/addPersonnelGroupPersonnel.json", //群组加入
  }
};
